import { createFileRoute } from '@tanstack/react-router';
import { OrganizationsPage } from '@/features/organizations';

export const Route = createFileRoute('/_auth/organizations/')({
  component: OrganizationsPage,
});
